<template>
  <div>
    <CContainer class="mb-4">
      <CRow>
        <CCol md="5">
          <CButton class="w-50" color="success" @click="goToCreate">
            <div class="button-text">
              <CIcon name="cil-plus" />
              <span>New</span>
            </div>
          </CButton>
        </CCol>
        <CCol md="4" class="justify-content-right">
          <CInput placeholder="Product Name" v-model="productName" @keydown.enter="searchProduct">
          </CInput>
        </CCol>
        <CCol md="3" class="justify-content-right">
          <CButton color="primary" @click="searchProduct">Search</CButton>
        </CCol>
      </CRow>
    </CContainer>
    <CContainer>
      <CRow v-if="products.length">
        <CCol md="12">
          <CCard>
            <CCardBody>
              <CDataTable :striped="true" :items="products" :fields="fields" :loading="isLoad">
                <template #name="{ item }">
                  <td>
                    {{ item.name }}
                  </td>
                </template>
                <template #price="{ item }">
                  <td>
                    {{ moneyFormatter(item.price) }}
                  </td>
                </template>
                <template #image="{ item }">
                  <td class="pt-0">
                    <a href="#" @click="onPreviewImage(0, item.image)" v-if="item.image">
                      <CImg class="product-image mt-2 w-50" :src="item.image[0]" :alt="item.image[0]" />
                    </a>
                    <span v-else>-</span>
                  </td>
                </template>
                <template #action="{ item }">
                  <td>
                    <CButton class="mb-2" color="primary" @click="viewItem(item)">
                      Detail
                    </CButton>

                    <CButton class="mb-2 ml-2 fix-margin" color="danger" @click="onDeleteProduct(item)">
                      Delete
                    </CButton>
                  </td>
                </template>
              </CDataTable>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
    <!-- Modal -->
    <CModal :title="productDetail.id" :closeOnBackdrop="false" :centered="true" :show.sync="modalVisible.view"
      class="detail-modal" size="lg">
      <CRow>
        <CCol sm="6" class="mb-2">
          <h5>Product ID:</h5>
        </CCol>
        <CCol sm="6">
          <h5>Product Name:</h5>
        </CCol>
      </CRow>

      <CRow>
        <CCol sm="6">
          {{ productDetail.id }}
        </CCol>
        <CCol sm="6">
          {{ productDetail.name }}
        </CCol>
      </CRow>

      <CRow class="mt-3 mb-2">
        <CCol sm="6">
          <h5>Chinese Name:</h5>
        </CCol>
        <CCol sm="6">
          <h5>Product Price:</h5>
        </CCol>
      </CRow>

      <CRow>
        <CCol sm="6">
          {{ productDetail.chinese_name || '-' }}
        </CCol>
        <CCol sm="6">
          <template v-if="productDetail.price">
            {{ moneyFormatter(productDetail.price) }}
          </template>
        </CCol>
      </CRow>

      <CRow class="mt-3" v-if="productDetail.image">
        <CCol sm="3" class="mb-3 d-flex justify-content-flex-start" v-for="(image, index) in productDetail.image"
          :key="index" @click="onPreviewImage(index, productDetail.image)">
          <CCard>
            <CCardBody class="p-2">
              <CImg alt="Product Image" :src="image" class="w-100 mb-3" />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>

      <CRow class="mb-2">
        <CCol sm="6">
          <h5>Category:</h5>
        </CCol>
      </CRow>

      <CRow>
        <CCol sm="6">
          <CButton class="sm-btn" block color="dark" disabled>
            {{ productDetail.category_name }}
          </CButton>
        </CCol>
      </CRow>

      <CRow class="mt-3">
        <CCol class="mb-2">
          <h5>Available Size:</h5>
        </CCol>
      </CRow>
      <CRow v-if="productDetail.available_size">
        <CCol :sm="3" v-for="(size, index) in productDetail.available_size" :key="index">
          <CButton class="mb-2" block color="info" disabled>
            {{ size.size }}
          </CButton>
        </CCol>
      </CRow>

      <CRow class="mt-3">
        <CCol class="mb-2">
          <h5>Occasion:</h5>
        </CCol>
      </CRow>
      <CRow v-if="productDetail.occasions">
        <CCol :sm="3" v-for="occasion in productDetail.occasions" :key="occasion.id">
          <CButton class="mb-2" block color="info" disabled>
            {{ occasion.occasion_name }}
          </CButton>
        </CCol>
      </CRow>

      <CRow class="mt-3">
        <CCol class="mb-2">
          <h5>Color:</h5>
        </CCol>
      </CRow>
      <CRow v-if="productDetail.colors">
        <CCol :sm="3" v-for="color in productDetail.colors" :key="color.id">
          <CButton class="mb-2" block color="dark" disabled>
            {{ color.color_name }}
          </CButton>
        </CCol>
      </CRow>
      <template #header>
        <h4 class="modal-title">Product Detail</h4>
        <CButtonClose @click="dismissModal" />
      </template>
      <template #footer>
        <div class="update-btn-wrapper">
          <CButton @click="onUpdateProduct" color="primary">Update Product</CButton>
        </div>
      </template>
    </CModal>

    <!-- Delete Modal -->
    <CModal title="Modal title" color="danger" :closeOnBackdrop="false" :centered="true"
      :show.sync="modalVisible.cancel">
      Are you sure you want to delete this product ?
      <template #header>
        <h5 class="modal-title">Confirm Delete</h5>
        <CButtonClose @click="dismissModal" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="deleteProduct" color="danger">OK</CButton>
        <CButton @click="dismissModal" color="secondary">Cancel</CButton>
      </template>
    </CModal>

    <!-- Pagination -->
    <CContainer>
      <CPagination v-if="products.length" :activePage.sync="page" :double-arrows="false" :pages="getPage"
        @update:activePage="changePage" />
    </CContainer>
  </div>
</template>

<script>
import { PRODUCT_GET, PRODUCT_DELETE, PRODUCT_GET_BY_NAME } from '../../../../constants/api'
import dateFormatter from '../../../../utils/dateFormatter'
import moneyFormatter from '../../../../utils/moneyFormatter'

import axios from 'axios'
import imagePreview from 'image-preview-vue'

export default {
  data() {
    return {
      dateFormatter,
      moneyFormatter,
      id: '',
      products: [],
      productDetail: {},
      fields: ['name', 'price', 'image', 'action'],
      modalVisible: {
        view: false,
        cancel: false,
      },
      page: 1,
      limit: 10,
      totalPage: 1,
      isLoad: false,
      accessToken: sessionStorage.getItem('access_token') || '',
      productName: ''
    }
  },

  beforeMount() {
    const payload = {
      start: 0,
    }
    this.fetchproducts(payload)
  },

  computed: {
    getPage() {
      return Math.ceil(this.totalPage / this.limit)
    },
  },

  methods: {
    fetchproducts(payload) {
      this.isLoad = true

      axios
        .get(PRODUCT_GET, {
          headers: {
            'x-access-token': this.accessToken,
          },
          params: payload,
        })
        .then((res) => {
          this.products = res.data.data
          this.limit = res.data.limitNum
          this.totalPage = res.data.totalCount
          this.isLoad = false
        })
    },

    changePage(pageNumber) {
      const payload = {
        start: (pageNumber - 1) * this.limit,
      }
      this.fetchproducts(payload)
    },

    viewItem(product) {
      this.productDetail = product
      this.modalVisible.view = true
    },

    onDeleteProduct(product) {
      this.productDetail = product
      this.id = product.id
      this.modalVisible.cancel = true
    },

    deleteProduct() {
      this.isLoad = true
      axios
        .delete(`${PRODUCT_DELETE}/${this.id}`, {
          headers: {
            'x-access-token': this.accessToken,
          },
        })
        .then(() => {
          this.isLoad = false

          const payload = {
            start: 0,
          }
          this.fetchproducts(payload)
          this.dismissModal()
        })
    },

    dismissModal() {
      this.id = ''
      this.productDetail = {}
      this.modalVisible.view = false
      this.modalVisible.cancel = false
    },

    goToCreate() {
      this.$router.push({ path: `create` })
    },

    onUpdateProduct() {
      const productId = this.productDetail.id
      this.$router.push({
        name: `Update Product`,
        params: {
          id: productId
        }
      })
    },

    onPreviewImage(index, images) {
      imagePreview({
        zIndex: 99999,
        initIndex: index,
        images,
        onClose: () => { }
      })
    },

    searchProduct() {
      if (this.productName) {
        const payload = {
          start: 0,
          name: this.productName
        }
        axios.get(PRODUCT_GET_BY_NAME, {
          params: payload
        })
          .then(({ data }) => {
            this.products = data.data
            this.totalPage = data.totalCount
            this.limit = data.limitNum
          })
          .catch(err => {
            console.log(err)
          })
      } else {
        const payload = {
          start: 0,
        }
        this.fetchproducts(payload)
      }
    }
  },
}
</script>

<style scoped>
.product-image {
  object-fit: contain;
  height: 100px;
  width: 100px;
}

h5 {
  display: inline;
}

.button-text {
  align-items: center;
  display: flex;
  justify-content: center;
}

.button-text>span {
  margin-left: 6px;
}

.sm-btn {
  width: 70%;
  display: inline;
}

/* .addon_name {
    font-size: 15px;
  } */
.update-btn-wrapper {
  width: 100%;
  text-align: center;
}

@media screen and (max-width: 1167px) {
  .fix-margin {
    margin-left: 0 !important;
  }
}
</style>